import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// @ts-ignore no types for this module
import sprintf from 'i18next-sprintf-postprocessor';

import en from './translations/locale/en.json';
import ro from './translations/locale/ro.json';
import uk from './translations/locale/uk.json';
import da from './translations/locale/da.json';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .use(sprintf)
    .init({
        debug: false,
        fallbackLng: 'en',
        load: 'languageOnly',
        interpolation: {
            escapeValue: false,
        },
        postProcess: 'sprintf',
        ns: ['marketing'],
        supportedLngs: ['en', 'ro', 'uk', 'da'],
        defaultNS: 'marketing',
        resources: {
            en: {
                marketing: en,
            },
            ro: {
                marketing: ro,
            },
            uk: {
                marketing: uk,
            },
            da: {
                marketing: da,
            },
        },
        detection: {
            caches: [],
        },
    });

export default i18n;
